import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { AppDispatch } from "../Store";
import { userSlice } from "../reducers/UserSlice";
import type { IUser } from "../types/UserTypes";
import { USER_URL, DELETE_USER_URL, POST_MESSAGE } from "./endpoints";
import { ICreateUser } from "../types/OperatorTypes";
import { operatorSlice } from "../reducers/OperatorSlice";
import { fstat } from "fs";
import { ICreateMessage } from "../types/OperatorTypes";

export const getAllUsers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(userSlice.actions.getUsersLoading());
    const res = await axios.get(USER_URL, { withCredentials: true });
    dispatch(userSlice.actions.getUsersSuccess(res.data));
  } catch (error: any) {
    dispatch(userSlice.actions.getUsersFailed(error.message));
  }
};

export const getUserById = (id: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(userSlice.actions.getUserLoading());
    const res = await axios.get(USER_URL + `/find-one?id=${id}`, {
      withCredentials: true,
    });
    dispatch(userSlice.actions.getUserSucces(res.data));
  } catch (error: any) {
    dispatch(userSlice.actions.getUserFailed(error.message));
  }
};

export const getUsersBySearch =
  (query: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(userSlice.actions.getUserLoading());
      const res = await axios.get(USER_URL + `/search?search=${query}`, {
        withCredentials: true,
      });
      dispatch(userSlice.actions.getUsersSuccess(res.data));
    } catch (error: any) {
      dispatch(userSlice.actions.getUsersFailed(error.message));
    }
  };

export const editUser =
  (userId: string, data: Partial<IUser>) => async (dispatch: AppDispatch) => {
    try {
      dispatch(userSlice.actions.updateUserLoading());

      const res = await axios.patch(USER_URL + `/update?id=${userId}`, data, {
        withCredentials: true,
      });
      dispatch(userSlice.actions.updateUserSuccess(res.data));
      return true;
    } catch (error: any) {
      dispatch(userSlice.actions.updateUserFailed(error.message));
      return false;
    }
  };

export const addUser =
  (user: ICreateUser) =>
  async (dispatch: AppDispatch): Promise<Boolean> => {
    try {
      dispatch(userSlice.actions.addUserLoading());
      const res = await axios.post(
        USER_URL,
        {
          name: user.name,
          telegramId: user.telegramId,
          phone: user.phone,
        },
        { withCredentials: true }
      );
      dispatch(userSlice.actions.addUserSuccess(res.data));

      return true;
    } catch (error: any) {
      dispatch(userSlice.actions.addUserFailed(error.message));
      return false;
    }
  };

export const deleteUser = (id: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(userSlice.actions.deleteUserLoading());

    await axios.delete(DELETE_USER_URL, {
      withCredentials: true,
      params: { id },
    });

    dispatch(userSlice.actions.deleteUserSuccess(id));
    return true;
  } catch (error: any) {
    dispatch(userSlice.actions.deleteUserFailed(error.message));
    return false;
  }
};

export const addMessage =
  (message: ICreateMessage) =>
  async (dispatch: AppDispatch): Promise<Boolean> => {
    try {
      dispatch(userSlice.actions.addMessageLoading());
      const res = await axios.post(
        POST_MESSAGE,
        {
          userId: message.userId,
          operatorId: message.operatorId,
          content: message.content,
          ticketId: message.ticketId,
        },
        { withCredentials: true }
      );
      dispatch(userSlice.actions.addMessageSuccess(res.data));
      return true;
    } catch (error: any) {
      dispatch(userSlice.actions.addMessageFailed(error.message));
      return false;
    }
  };


export const addMessagesMany = createAsyncThunk(
  "messages/addMany",
  async (dtos: ICreateMessage[]) => {
    const response = await axios.post(
      POST_MESSAGE,   
      dtos,
      { withCredentials: true }
    );
    
    return {
      message: "Сообщение удачно отправлено",
      data: response.data 
    };
  }
);